import { Component, OnInit, AfterViewChecked, ViewChild } from '@angular/core';
import { IngredientService, Ingredient } from '../../services/ingredient.service';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { NgForm } from '@angular/forms';
import { BaseComponent } from '../base.component';
import { CategoryService, Category } from '../../services/category.service';
import { TonalityService, Tonality } from '../../services/tonality.service';
import { ColorShadeService, ColorShade } from '../../services/color-shade.service';
import { PigmentService, Pigment } from '../../services/pigment.service';
import { Document } from "app/services/document.service";
import { NotificationsService } from "angular2-notifications";


@Component({
	selector   : 'app-edit-ingredient',
	templateUrl: './ingredient-form.html',
})

export class IngredientAddEdit extends BaseComponent implements OnInit, AfterViewChecked {

	param_id   : string;
	item       : Ingredient;
	categories : Category[];
	tonalities : Tonality[];
	colorShades: ColorShade[];
	pigments   : Pigment[];
	notValid   : any;

	formTitle  = 'Add Product';
	buttonText = 'Save Product';

	current_doc_type: string;

	ingForm: NgForm;
	@ViewChild('ingForm') currentForm: NgForm;

	constructor(
		private ingredientService: IngredientService,
		private router           : Router,
		private route            : ActivatedRoute,
		private categoryService  : CategoryService,
		private tonalityService  : TonalityService,
		private colorShadeService: ColorShadeService,
		private pigmentService   : PigmentService,
		private notificationsService: NotificationsService,
	) {
		super();
	}

	ngOnInit() {
		this.param_id = this.route.snapshot.params['id'];
		this.item     = new Ingredient();
		if (this.param_id) {
			this.formTitle  = 'Edit Product';
			this.buttonText = 'Update Product';
			this.ingredientService.getIngredient(this.param_id).subscribe(ingredient => {
				this.item = Object.assign(new Ingredient(), ingredient);
			});
		}

		this.categoryService.getCategories().subscribe((categories) => {
			this.categories = categories.filter(item => {
				return item.goes_to != 'sub';
			})
		});
		this.tonalityService.getTonalities().subscribe((tonalities) => {
			this.tonalities = tonalities;
		});
		this.colorShadeService.getColorShades().subscribe((colorShades) => {
			this.colorShades = colorShades;
		});
		this.pigmentService.getPigments().subscribe((pigments) => {
			this.pigments = pigments;
		});
	}

	trackByIndex(index: number, obj: any): any {
		return index;
	}

	documentSelected(document: Document) {
		if (this.current_doc_type == 'doc_spec') {
			this.item.doc_spec = document.url[0];
		}
		if (this.current_doc_type == 'doc_MSDS') {
			this.item.doc_MSDS = document.url[0];
		}
		if (this.current_doc_type == 'doc_TDS') {
			this.item.doc_TDS = document.url[0];
		}
		if (this.current_doc_type == 'doc_halal') {
			this.item.doc_halal = document.url[0];
		}
	}

	doc_selector(type) {
		this.current_doc_type = type;
	}

	onRemoveDoc(doc){
		if(doc == 'spec'){
			this.item.doc_spec = '';
		} else if(doc == 'msds') {
			this.item.doc_MSDS = '';
		} else if(doc == 'tds') {
			this.item.doc_TDS = '';
		} else if (doc == 'halal') {
			this.item.doc_halal = '';
		}
	}

	formAction() {
		var self = this;
		this.item.packaging_size = this.item.packaging_size.filter(item => {
			return !!item;
		}).map(item => {
			return item + '';
		});

		this.item.moq = this.item.moq.filter(item => {
			return !!item;
		}).map(item => {
			return item + '';
		});

		this.item.lead_time = this.item.lead_time + '';

		if (!this.formValidation(false)) {
			window.scrollTo(0, 0);
		} else {

			if (this.param_id) {
				this.ingredientService.updateIngredient(this.param_id, this.item).then(function () {
					self.notificationsService.success('Updated', '1 product updated');
					self.router.navigate(['/product']);
				}).catch(function (error) {
					console.log('Hayoloh, ada error. Error: ' + error.message);
				});
			}
			else {
				var exist = this.ingredientService.getIngredient(this.item.sap_code);
				exist.$ref.once('value').then(snapshot => {
					if (snapshot.val()) {
						self.notificationsService.error('Product with same SAP code is exist.');
					}
					else {
						self.notificationsService.success('Added', '1 product added');
						self.router.navigate(['/product']);
						this.ingredientService.updateIngredient(this.item.sap_code, this.item).then(function () {
						}).catch(function (error) {
							console.log('Hayoloh, ada error. Error: ' + error.message);
						});
					}
				});
			}
		}
	}

	ngAfterViewChecked() {
		this.formChanged();
	}

	formChanged() {
		if (this.currentForm === this.ingForm) { return; }

		this.ingForm = this.currentForm;
		if (this.ingForm) {
			this.ingForm.valueChanges
				.subscribe(data => {
					this.formValidation(true)
				});
		}
	}

	formValidation(checkDirty = true) {
		const form = this.ingForm.form;
		for (const field in form.controls) {
			const control = form.get(field)
			if (control) {
				if (checkDirty && !control.dirty) {
					continue;
				}
				this.formErrors[field] = '';
				if (!control.valid) {
					const messages = this.validationMessages[field] || {};
					for (const key in control.errors) {
						this.formErrors[field] += messages[key] + ' ';
					}
				}
			}
		}

		return form.valid;
	}

	formErrors = {
		'productName'           : '',
		'category_id'           : '',
		"SAPCode"				: '',
	};

	validationMessages = {
		'SAPCode': {
			'required': 'This field is required.',
		},
		'productName': {
			'required': 'This field is required.',
		},
		'category_id': {
			'required': 'This field is required.',
		},
	};

}



// WEBPACK FOOTER //
// D:/www/kh_indesso_web/src/app/components/ingredient/ingredient-add-edit.component.ts